import { Typography } from '@mui/material'

interface RequiredLabelPrefixProps {
  required?: boolean
}

const RequiredLabelPrefix: React.FC<RequiredLabelPrefixProps> = ({ required }) => {
  if (required === true) {
    return (
      <>
        <Typography
          component='span'
          sx={{
            color: (theme) => theme.palette.primary.main,
            fontWeight: '700',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            mr: '6px'
          }}
        >
          *
        </Typography>
      </>
    )
  }
  return <></>
}

export default RequiredLabelPrefix
